import {useSelector} from 'react-redux';
import {HouseQueAppState} from '../../houseque';

export const useStagedPhotos = () => {
  return useSelector((state: HouseQueAppState) => {
    return state.photos.staged;
  });
};
